import { ZonedDateTimeFactory, ZonedDateTimeFormatter } from '@csp/csp-common-date-util';
import { MessageBatchV1, MessageTypeV1, MessageV1 } from '@csp/dmdp-api-usage-tracker-dto';
import { UsageTrackerEventTypes } from '../model/UsageTrackerEventTypes';

const toMessageTypeV1 = (type: string): MessageTypeV1 => {
  switch (type) {
    case 'identify':
      return MessageTypeV1.IDENTIFY;
    case 'group':
      return MessageTypeV1.GROUP;
    case 'track':
      return MessageTypeV1.TRACK;
    case 'page':
      return MessageTypeV1.PAGE;
    case 'screen':
      return MessageTypeV1.SCREEN;
    case 'alias':
      return MessageTypeV1.ALIAS;
    default:
      throw new Error(`Unknown message type ${type}`);
  }
};

const toMessageV1 = (usageTrackerEvent: UsageTrackerEventTypes): MessageV1 => {
  const { properties, messageId, timestamp, anonymousId, context, integrations, version, userId } = usageTrackerEvent;

  const messageV1: MessageV1 = {
    type: toMessageTypeV1(usageTrackerEvent.type),
    properties,
    messageId,
    timestamp: ZonedDateTimeFormatter.toIsoFormattedString(timestamp),
    anonymousId,
    context,
    integrations,
    version,
    userId,
  };

  if (usageTrackerEvent.type === MessageTypeV1.TRACK) {
    messageV1.event = usageTrackerEvent.event;
  }

  if (usageTrackerEvent.type === MessageTypeV1.SCREEN) {
    messageV1.name = usageTrackerEvent.name;
  }

  if (usageTrackerEvent.type === MessageTypeV1.PAGE) {
    messageV1.name = usageTrackerEvent.name;
  }

  return messageV1;
};

const toMessageBatchV1 = (events: UsageTrackerEventTypes[], writeKey?: string): MessageBatchV1 => ({
  writeKey,
  sentAt: ZonedDateTimeFormatter.toIsoFormattedString(ZonedDateTimeFactory.now()),
  batch: events.map(event => toMessageV1(event)),
});

export const UsageTrackerMapper = {
  toMessageBatchV1,
  toMessageV1,
};
